<template>
    <div>
        <navbar></navbar>
        <div class="__policybg">
            <div class="container">
                <p class="__bepro">Privacy policy</p>
            </div>
        </div><br>
        <div class="container">
            <div class="row">
                <div class="col-md-2 col-sm-2"></div>
                <div class="col-md-8 col-sm-8">
                    <p class="__term">We absolutely respect your privacy and we do not sell/trade or share personal information with organizations or individuals not connected with the services of this site. This section explains what information is stored and how it is used.</p>

                    <div class="accordion  __term">
                        <h4 class="accordion-toggle">Information that we collect and store</h4>
                        <div class="accordion-content">
                            <p>
                                We only collect, store or use information that we consider necessary for the purpose of providing the best service possible to all of our members. You are free to browse our website without providing any personal information to us.
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle">How we use this information</h4>
                        <div class="accordion-content">
                            <p>
                                We check the accuracy of the information that you provide on registration as part of the process of verifying information provided by members we may carry out, either directly or via carefully selected and appropriately regulated third party. This may include cross-referencing the information you have provided, If you do not consent to such checks being carried out please do not register with us. <br>
                                We may use the contact information you provide to contact you via email, post or telephone regarding your registration, or any other matter that we consider relevant to your use of our Service.<br>
                                We may use any information we collect about you, including any information we may have obtained from your use of the Service, to resolve disputes, provide customer/client support, troubleshoot problems and enforce our Terms and conditions and policies. We may look across multiple users to identify problems or resolve disputes. <br>
                                We may disclose your personal data if we are compelled to do so by law, or in response to a valid, legally compliant request by a law enforcement or governmental authority. We may also disclose aggregated demographic and profile data (in which neither you nor any other individual is identified) to our commercial partners.
                            </p>
                            <hr>
                        </div>
                        
                        <h4 class="accordion-toggle"> Security measures</h4>
                        <div class="accordion-content">
                            <p>
                                No data transmission over the internet can be entirely secure, so we do not guarantee the security of your personal information and/or use of the Site. However, to prevent unauthorised access, maintain accuracy of our records and to ensure proper use and protection of your Information, we have put appropriate physical, electronic and managerial procedures in place. <br>
                                However, we cannot guarantee the security of any information or data which is transmitted over public or third party networks. Please note: you must ensure that your password remains secret.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">Cookies</h4>
                        <div class="accordion-content">
                            <p>
                                This website uses cookies to identify repeat visitors. We protect your privacy by only storing a simple ID number and token string that is only meaningful to this website. Your personal details, such as your name or phone number, are not stored in a cookie. You may set your computer browser to reject cookies but this may preclude your use of certain parts of the Service.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">Retention of your information</h4>
                        <div class="accordion-content">
                            <p>
                                We will retain your personal information only as long as is necessary for the purposes to which you consent under this Privacy Policy, after which we will delete it from our systems.
                            </p>
                            <hr>
                        </div>

                        <h4 class="accordion-toggle">Access to information</h4>
                        <div class="accordion-content">
                            <p>
                                We may ask for proof of identity before providing you with any information requested in regards to our services and we reserve the right to refuse to provide information if identity is not established.<br>
                                Any changes to this policy will be posted on this Website. If you have any further comments or questions regarding our Terms and conditions and Privacy policy then kindly contact us – we’re ready to help.
                            </p>
                            <hr>
                        </div>

                    </div>
                </div>
                <div class="col-md-2 col-sm-2"></div>
            </div>
        </div><br><br>
        
    </div>
</template>

<script>
import navbar from '../components/navbar';


export default {
    components: { navbar,
    },

    mounted() {
        $(document).ready(function() {
            $('.accordion').find('.accordion-toggle').click(function() {
                $(this).next().slideToggle('600');
                $(".accordion-content").not($(this).next()).slideUp('600');
            });
            $('.accordion-toggle').on('click', function() {
                $(this).toggleClass('active').siblings().removeClass('active');
            });
        });
    }
}
</script>

<style scoped>
    .__bepro{
        font-size: 50px;
        font-weight: 600;
        line-height: 1.2;
        color: #ffffff;
    }

    .__term {
        font-size: 14px;
        line-height: 1.65;
        color: #000000;
        margin-top: 18px;
    }

    .accordion{
        width:100%; 
        margin: 0 auto;
    }
    .accordion-toggle {
        border-bottom: 1px solid #cccccc;
        cursor: pointer;
        margin: 0;
        padding: 20px 0;
        position: relative;
    }
    .accordion-toggle.active:after{
        content:"";
        position:absolute;
        right:0;top:17px;
        width:0;height:0;
        border-bottom:5px solid #0000ef;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle:before{
        content:"";
        position:absolute;
        right:0;
        top:25px;
        width:0;
        height:0;
        border-top:5px solid #000;
        border-left:5px solid #fff;
        border-right:5px solid #fff;
    }
    .accordion-toggle.active:before{
        display:none;
    }
    .accordion-content {
        display: none;
        font-size: 16px;
        padding: 20px 0;
        text-align: justify;
    }
    .accordion-toggle.active {
        color: #0000ef;
    }
</style>


// WEBPACK FOOTER //
// src/components/policy.vue